// Labels & UI mappings for hacker-style status and threat-level priority.
export const STATUSES = [
  { value: "brecha_detectada", label: "BRECHA DETECTADA", short: "Brecha Detectada", tone: "danger" },
  { value: "infiltracion_en_curso", label: "INFILTRACIÓN EN CURSO", short: "Infiltración en curso", tone: "warning" },
  { value: "parche_aplicado", label: "PARCHE APLICADO", short: "Parche Aplicado", tone: "success" },
];

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.value, s]));

export const PRIORITIES = [
  { value: "bajo", label: "BAJO", short: "Nivel Bajo", tone: "low" },
  { value: "medio", label: "MEDIO", short: "Nivel Medio", tone: "mid" },
  { value: "alto", label: "ALTO", short: "Nivel Alto", tone: "high" },
];

export const PRIORITY_MAP = Object.fromEntries(PRIORITIES.map((p) => [p.value, p]));

export function statusChipClass(value) {
  const s = STATUS_MAP[value];
  if (!s) return "chip";
  return `chip chip-status-${s.tone}`;
}

export function priorityChipClass(value) {
  const p = PRIORITY_MAP[value];
  if (!p) return "chip";
  return `chip chip-prio-${p.tone}`;
}
